import { FlexDiv } from "components/Layout/FlexDiv";
import { FC, useEffect, useState } from "react";
import { useSelectedSubscription } from "../context/subscription";
import User from "./User";
import { ProspectsWrapper } from "./styles";
import Add from "assets/images/add.png";
import AddNewUserModal from "components/Modal/AddNewUserModal";
import { useAuth } from "context/auth";
import { useSearchBar } from "context/searchbar";
import { CircularProgress } from "@mui/material";

const Prospects: FC = () => {
  const { admin } = useAuth();
  const {
    subscription,
    searchText,
    setSearchText,
    userIdFilter,
    setUserIdFilter,
    isLoadingSubscription,
  } = useSelectedSubscription();
  const { searchUserId } = useSearchBar();
  const [open, setOpen] = useState<boolean>(false);

  // Searching a user id in the topbar selects the subscription that owns it, so
  // carry it over to narrow the users list down to that same user
  useEffect(() => {
    setUserIdFilter(searchUserId);
  }, [searchUserId, setUserIdFilter]);

  const handleOpenModal = () => {
    setOpen(true);
  };

  const handleSearchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSearchText(event.target.value);
  };

  const handleUserIdChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setUserIdFilter(event.target.value);
  };

  if (!subscription) {
    return (
      <FlexDiv>
        <span> Please select a subscription</span>
      </FlexDiv>
    );
  }

  return (
    <>
      <AddNewUserModal
        open={open}
        setOpen={setOpen}
        subscription={subscription}
      />
      <ProspectsWrapper>
        <FlexDiv
          height="unset"
          className="prospects-card-title"
          justifyContent="space-between"
          alignItems="center"
        >
          <h3 className="prospect-title">
            Users -{" "}
            <span className="account-name">{subscription.company.name}</span>
          </h3>
          <div className="header-actions">
            <input
              type="text"
              placeholder="Search users..."
              value={searchText}
              onChange={handleSearchChange}
              className="search-input"
            />
            <input
              type="text"
              inputMode="numeric"
              placeholder="User ID"
              value={userIdFilter}
              onChange={handleUserIdChange}
              className="search-input user-id-input"
            />
            <span className="prospect-add">
              {admin?.canCreate && (
                <img
                  className="pointer"
                  src={Add}
                  alt="add"
                  width="24px"
                  onClick={() => handleOpenModal()}
                />
              )}
            </span>
          </div>
        </FlexDiv>
        <div className="prospects">
          {isLoadingSubscription ? (
            <FlexDiv>
              <CircularProgress />
            </FlexDiv>
          ) : (searchText || userIdFilter) &&
            (!subscription?.users || subscription.users.length === 0) ? (
            <FlexDiv>
              <span>There are no users with this name, email or ID</span>
            </FlexDiv>
          ) : (
            subscription?.users?.map((user) => (
              <User key={user.id} user={user} subscription={subscription} />
            ))
          )}
        </div>
      </ProspectsWrapper>
    </>
  );
};

export default Prospects;
